<script lang="ts">
  interface Props {
    title: string
    onclose: () => void
    children?: any
    footer?: any
    wide?: boolean
  }
  let { title, onclose, children, footer, wide = false }: Props = $props()

  function keyHandler(e: KeyboardEvent) {
    if (e.key === 'Escape') onclose()
  }
</script>

<svelte:window onkeydown={keyHandler} />

<div class="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4"
     role="dialog" aria-modal="true" onclick={(e) => e.target === e.currentTarget && onclose()}>
  <div class="bg-bg-card border border-bg-border rounded-t-xl sm:rounded-xl shadow-2xl w-full {wide ? 'max-w-3xl' : 'max-w-md'} max-h-[95vh] sm:max-h-[85vh] flex flex-col">
    <header class="px-4 sm:px-5 py-3 sm:py-4 border-b border-bg-border flex items-center justify-between">
      <h2 class="text-base font-semibold">{title}</h2>
      <button class="btn-icon" onclick={onclose} aria-label="Закрыть">×</button>
    </header>
    <div class="p-4 sm:p-5 overflow-y-auto flex-1">
      {@render children?.()}
    </div>
    {#if footer}
      <footer class="px-4 sm:px-5 py-3 border-t border-bg-border flex justify-end gap-2 bg-bg-sunk/50 rounded-b-xl flex-wrap">
        {@render footer()}
      </footer>
    {/if}
  </div>
</div>
